import React, { useContext } from 'react';
import styled from 'styled-components';
import { Loader } from '@ubeya/shared-web/components';
import useEmployeeHiring from '@ubeya/shared/hooks/employees/useEmployeeHiring';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { EmptyState } from 'shared/components';
import { RootContainer, RootWrapper } from '../styled';
import HiringApplicationCard from './HiringApplicationCard';

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const EmployeeHiring = ({ employeeId, accountId, onNavigate }) => {
  const { t } = useContext(ConfigContext);
  const { isLoading, applications } = useEmployeeHiring({ employeeId });

  if (!isLoading && applications.length === 0) {
    return (
      <RootWrapper>
        <EmptyState text={t('noEmployeeHiringApplications')} />
      </RootWrapper>
    );
  }

  return (
    <RootWrapper>
      <RootContainer>
        <List>
          {applications.map((application) => (
            <HiringApplicationCard
              key={application.applicationId}
              application={application}
              accountId={accountId}
              onNavigate={onNavigate}
            />
          ))}
        </List>

        {isLoading && <Loader />}
      </RootContainer>
    </RootWrapper>
  );
};

export default React.memo(EmployeeHiring);
